import { useTranslation } from '../../../../utils/useTranslation';
import { WithHint } from '../../../feedback/Tooltip';
import { Typography } from '../../../typography/Typography';
import { BusinessType } from '../../types';
import { textDictionary, validateBloggersRegister, validateUrl } from '../constants';
import { LinkField } from './LinkField';
import { SocialLinkFields } from './SocialLinkFields';

export const BloggerFields = ({
    onFieldBlur,
}: {
    onFieldBlur: (name: string, value: string) => void;
}) => {
    const t = useTranslation();
    const textMap = textDictionary[BusinessType.BLOGGER];

    return (
        <>
            <Typography variant="title2" weight="bold" py={2}>
                {t('Зарегистрироваться в Яндекс Ритме')}
            </Typography>
            <Typography variant="body">{t(textMap.registerDisclaimer)}</Typography>

            <Typography variant="title3" weight="bold" py={2}>
                <WithHint message={t(textMap.socialLinksHint)}>{t(textMap.socialLinks)}</WithHint>
            </Typography>
            <SocialLinkFields
                businessType={BusinessType.BLOGGER}
                onFieldBlur={onFieldBlur}
                requireAtLeastOne
            />

            <Typography variant="title3" weight="bold" py={2}>
                {t('Дополнительная информация')}
            </Typography>
            <Typography variant="body" pb={2}>
                {t(
                    'Вы можете добавить другие профили в социальных сетях и регистрацию в реестре блогеров, это поможет нам лучше оценить вашу аудиторию.',
                )}
            </Typography>

            <LinkField
                name="otherUrl"
                validate={validateUrl}
                label={t('Ссылка на ваш профиль на любом другом ресурсе')}
                placeholder="https://"
                onFieldBlur={onFieldBlur}
            />
            <LinkField
                name="bloggersRegisterUrl"
                validate={validateBloggersRegister}
                label={t('Регистрация в реестре блогеров')}
                placeholder="https://www.gosuslugi.ru/..."
                onFieldBlur={onFieldBlur}
            />
            <LinkField
                name="email"
                required
                disabled
                label={t('Адрес электронной почты')}
                placeholder="Не заполнено"
                onFieldBlur={onFieldBlur}
            />
            <Typography variant="caption" color="secondary">
                {t('На вашу почту мы будем присылать важные уведомления от сервиса')}
            </Typography>
        </>
    );
};
